/**
 * @file 开发者社区 社区资源
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React, { useEffect } from 'react';
import { ICommunityResources } from './../../types';
import { RightOutlined } from '@ant-design/icons';

import './style.less';

const DeveloperCommunityResource: React.FC<ICommunityResources> = props => {
    const { title, list = [] } = props;

    // 处理一下其他链接的锚点跳转，平滑滚动元素
    useEffect(() => {
        const anchorID = (new URLSearchParams(window.location.search.slice(1))).get('id');
        const anchorDom = document.querySelector(`#${anchorID}`);
        if (anchorID && anchorDom) {
            anchorDom.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            })
        }
    }, [title]);
    
    return (
        <div className="developer-community-resource-wrapper">
            <div className="community-resource-title" id="communityResource">{title}</div>
            <div className="community-resource-card-wrapper">
                {
                    list.map(item =>
                        <div className="community-resource-card" key={item.title}>
                            <div className="community-resource-content">{item.title}</div>
                            <a href={item.link}>
                                <div className="community-resource-content-simple">
                                    <div className="community-resource-content-title">{item.title}&nbsp;<RightOutlined /></div>
                                    <div className="community-resource-content-desc">{item.desc}</div>
                                </div>
                            </a>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default DeveloperCommunityResource;